import api from './authService';

export const openprojectService = {
  testConnection: async () => {
    const response = await api.get('/openproject/test-connection');
    return response.data;
  },

  getProjects: async () => {
    const response = await api.get('/openproject/projects');
    return response.data;
  },

  getWorkPackages: async (projectId, filters = '[]') => {
    const response = await api.get(`/openproject/projects/${projectId}/work_packages?filters=${encodeURIComponent(filters)}`);
    return response.data;
  },

  getAllWorkPackages: async (filters = '[]') => {
    const response = await api.get(`/openproject/work_packages?filters=${encodeURIComponent(filters)}`);
    return response.data;
  },

  getTimeEntries: async (filters = '[]', pageSize = 50, offset = 0) => {
    const params = new URLSearchParams({
      filters: filters,
      pageSize: pageSize.toString(),
      offset: offset.toString()
    });
    const response = await api.get(`/openproject/time_entries?${params}`);
    return response.data;
  },

  getWorkPackageDetails: async (workPackageId) => {
    const response = await api.get(`/openproject/work_packages/${workPackageId}`);
    return response.data;
  },

  // Backend returns a plain array (already unwrapped from OpenProject's
  // HAL collection shape) - normalize defensively in case that ever changes.
  getUsers: async () => {
    const response = await api.get('/openproject/users');
    const data = response.data;
    return Array.isArray(data) ? data : data._embedded?.elements || [];
  },

  getTelegramMessages: async (page = 1, limit = 50, filters = {}) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    // Add filter parameters
    if (filters.userId) params.append('userTitle', filters.userId);
    if (filters.workPackageId) params.append('workPackageId', filters.workPackageId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    
    const response = await api.get(`/openproject/telegram-messages?${params}`);
    return response.data;
  },

  // Update time entry status
  updateTimeEntryStatus: async (timeEntryId, status) => {
    const response = await api.patch(`/openproject/time-entries/${timeEntryId}/status`, { status });
    return response.data;
  },

  // Resend Telegram message
  resendTelegramMessage: async (timeEntryId) => {
    const response = await api.post(`/openproject/time-entries/${timeEntryId}/resend-telegram`);
    return response.data;
  }
};
